import { IRadioFilter } from 'types/location.js';
import { CONST_EMPTY_ARRAY } from 'utilities/consts/variable-types.js';
import { getFirstOfArr } from 'utilities/isType.js';
import { RADIO_FILTER_ALL } from './legends-filter-consts';

export interface LegendsRadioFilterProps {
  radioFilterOnClick: (markerType: string) => void;
  radioActiveFilter?: string[];
  radioFilters?: Array<IRadioFilter>;
  radioFilterLabel?: string;
}

const DEFAULT_RADIO_FILTER_LABEL = 'Select a Marker Type';

export const LegendsRadioFilters = ({
  radioFilters = CONST_EMPTY_ARRAY,
  radioActiveFilter = CONST_EMPTY_ARRAY,
  radioFilterLabel,
  radioFilterOnClick,
}: LegendsRadioFilterProps) => {
  const radioFiltersArePopulated = radioFilters.length > 0 ? radioFilters : undefined;

  if (radioFiltersArePopulated) {
    /** If RadioFilter labels are populated and don't include an item with label `all` then add one */
    const radioFilterIncludesAllOption = radioFilters.find((r) => r.label === RADIO_FILTER_ALL.label);
    const _radioFilters =
      radioFiltersArePopulated && !radioFilterIncludesAllOption
        ? [RADIO_FILTER_ALL].concat(radioFilters)
        : radioFilters;

    /**
     * RadioFilters is an array
     * All markers matching types in the array are shown on the map
     * The first item in the array is the active filter in the legend
     * This allows for a sort order to be applied when 'all' is selected
     */
    const radioFilterKey = getFirstOfArr(radioActiveFilter);

    return (
      <>
        <p className="h2 u-pB-xs u-bB-1 u-mT-responsive">{radioFilterLabel || DEFAULT_RADIO_FILTER_LABEL}</p>
        {_radioFilters.map(({ key, label }, idx) => {
          const radioLabelId = `radio-${key}`;
          const checked = radioFilterKey === key;

          return (
            <label htmlFor={radioLabelId} className="Radio" key={idx}>
              <input
                id={radioLabelId}
                className="Radio-input"
                type="radio"
                checked={checked}
                name={radioLabelId}
                onChange={() => radioFilterOnClick(key)}
              />
              <small className="Radio-label Radio-label--rightAlign">{label}</small>
            </label>
          );
        })}
      </>
    );
  }
  return null;
};
